import {isIos} from './utils'
export default {
	onShow() {
		console.log('-----show')
		this.$wxShare()
	},
	data() {
		return {
			share: {
				title: '阿牛数据',
				//    imageUrl:'https://ossweb-img.qq.com/images/lol/web201310/skin/big10001.jpg',
				path: 'pages/HomePage',
				authPathList: []
			}
		}
	},
	computed: {
		userInfo() {
			return this.$store.state.userInfo
		}
	},
	methods: {
		showVipModal() {
			uni.showModal({
				title: isIos() ? '提醒' : '开通会员',
				content: isIos() ? '请通过安卓系统或者网站(https://aniudata.com)开通会员' : '开通会员立即查看',
				confirmText: isIos() ? '我知道了' : '立即开通',
				success: (res) => {
					if(res.confirm && !isIos()) {
						uni.navigateTo({
							url: `/subpages/payment/sellPage`
						})
					}
				}
			})
		}
	},
	onShareAppMessage(res) { //发送给朋友
		return {
			title: this.share.title,
			// imageUrl: this.share.imageUrl,
			path: this.share.path,
		}
	},
	onShareTimeline(res) { //分享到朋友圈
		return {
			title: this.share.title,
			// imageUrl: this.share.imageUrl,
			path: this.share.path,
		}
	},
}
